import {
  BusinessState,
  DataState,
  DeliveryItems,
  ProductQuantitiesChange,
  UiState,
} from '../../models';
import { getDeliveryShopKey, getDeliveryTypeByDate } from '../../shared/shared';
import { productQuantitiesBusiness } from '../quantities/quantities-change/product-quantity.reducer';

export function deliveryPeriodQuantityChanges(
  sourceDeliveryItems: DeliveryItems,
  shopId: string,
  toDeliveryPeriods: string[],
) {
  const changes: ProductQuantitiesChange[] = [];
  Object.entries(sourceDeliveryItems.items ?? {}).forEach(
    ([productId, deliveryItem]) => {
      toDeliveryPeriods.forEach((deliveryPeriod) => {
        changes.push({
          productId,
          accountAddressKey: shopId,
          quantity: deliveryItem.quantity,
          note: deliveryItem.note,
          deliveryPeriod,
          // Copying correctly work here it should be smarter about following line
          deliveryPeriodType: getDeliveryTypeByDate(deliveryPeriod),
        });
      });
    },
  );

  return changes;
}

/**
 *
 * @param fromShop Key of the source shop accountId-addressId
 * @param fromDeliveryPeriod Key of the source delivery period
 * @param toDeliveryPeriod Key of the target delivery period
 * @param state current state
 */
export function copyDeliveryPeriod(
  fromShops: string[],
  fromDeliveryPeriod: string,
  toDeliveryPeriods: string[],
  state: BusinessState,
  data: DataState,
) {
  let changes: ProductQuantitiesChange[] = [];
  fromShops.forEach((fromShop) => {
    const sourceShopItems = state.deliveryItems[fromShop]?.[fromDeliveryPeriod];
    if (!sourceShopItems || !Object.keys(sourceShopItems).length) {
      return state;
    }

    // replicates the data from the source
    changes = [
      ...changes,
      ...deliveryPeriodQuantityChanges(
        sourceShopItems,
        fromShop,
        toDeliveryPeriods,
      ),
    ];
  });

  return productQuantitiesBusiness(state, { changes, data });
}

export function copyToDeliveryPeriodBusiness(
  state: BusinessState,
  {
    fromDeliveryPeriod,
    toDeliveryPeriods,
    allShops,
    data,
  }: {
    fromDeliveryPeriod: string;
    toDeliveryPeriods: string[];
    allShops?: boolean;
    data: DataState;
  },
): BusinessState {
  const fromShop = allShops
    ? data?.deliveryShops?.map((shop) => getDeliveryShopKey(shop)) ?? []
    : [getDeliveryShopKey(state.activeDeliveryShop)];

  return {
    ...state,
    ...copyDeliveryPeriod(
      fromShop,
      fromDeliveryPeriod,
      toDeliveryPeriods,
      state,
      data,
    ),
    dirty: true,
  };
}

export function copyToDeliveryPeriodUi(
  state: UiState,
  {
    toDeliveryPeriods,
  }: {
    fromDeliveryPeriod: string;
    toDeliveryPeriods: string[];
    allShops?: boolean;
  },
): UiState {
  const copiedDeliveryPeriods = new Set([
    ...state.copiedDeliveryPeriods,
    ...toDeliveryPeriods,
  ]);
  return {
    ...state,
    copiedDeliveryPeriods: [...copiedDeliveryPeriods],
    copiedShops: [],
  };
}
